import { ReactNode } from 'react'

import styles from './ControlsRowItem.scss'


type Props = {
  width: string
  children: ReactNode
}

export const ControlsRowItem = ({ width, children }: Props) => {
  return (
    <div className={styles.root} style={{ flexBasis: width }}>{children}</div>
  )
}
